'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isDragging = false;

var _default = function _default(element, options) {
  var moveFn = function moveFn(event) {
    if (options.drag) {
      options.drag(event);
    }
  };
  var upFn = function upFn(event) {
    document.removeEventListener('mousemove', moveFn);
    document.removeEventListener('mouseup', upFn);
    document.onselectstart = null;
    document.ondragstart = null;

    isDragging = false;

    if (options.end) {
      options.end(event);
    }
  };
  element.addEventListener('mousedown', function (event) {
    if (isDragging) return;
    document.onselectstart = function () {
      return false;
    };
    document.ondragstart = function () {
      return false;
    };

    document.addEventListener('mousemove', moveFn);
    document.addEventListener('mouseup', upFn);
    isDragging = true;

    if (options.start) {
      options.start(event);
    }
  });
};

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isDragging, 'isDragging', 'src/color-picker/draggable.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/color-picker/draggable.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ../node_modules/element-react/dist/npm/es5/src/color-picker/draggable.js
// module id = 236
// module chunks = 0